import {
    ArticlePublicSchema,
    ContentStatusSchema,
    CoursePublicSchema,
    EventPublicSchema,
    IsoDateTimeSchema,
    RecipePublicSchema,
    StreamPublicSchema,
    UuidSchema
} from '@cookspace-shared-contracts/core';
import { z } from 'zod';

/**
 * Локальные Zod-схемы для модерации контента.
 * admin-backend держит эти контракты у себя локально (не в shared-contracts),
 * поэтому admin SPA дублирует их форму здесь для парсинга ответов.
 */

export const ModerationContentTypeSchema = z.enum([
    'recipe',
    'article',
    'course',
    'stream',
    'event'
]);
export type ModerationContentType = z.infer<typeof ModerationContentTypeSchema>;

export const ModerationQueueItemSchema = z.object({
    id: UuidSchema,
    type: ModerationContentTypeSchema,
    title: z.string(),
    authorId: UuidSchema,
    authorDisplayName: z.string(),
    createdAt: IsoDateTimeSchema,
    status: ContentStatusSchema
});

export type ModerationQueueItem = z.infer<typeof ModerationQueueItemSchema>;

export const GetModerationQueueResponseSchema = z.object({
    items: z.array(ModerationQueueItemSchema),
    total: z.number().int()
});

export type GetModerationQueueResponse = z.infer<typeof GetModerationQueueResponseSchema>;

export const GetModerationRecipeResponseSchema = z.object({
    recipe: RecipePublicSchema
});

export type GetModerationRecipeResponse = z.infer<typeof GetModerationRecipeResponseSchema>;

export const GetModerationArticleResponseSchema = z.object({
    article: ArticlePublicSchema
});

export type GetModerationArticleResponse = z.infer<typeof GetModerationArticleResponseSchema>;

export const GetModerationCourseResponseSchema = z.object({
    course: CoursePublicSchema
});

export type GetModerationCourseResponse = z.infer<typeof GetModerationCourseResponseSchema>;

export const GetModerationStreamResponseSchema = z.object({
    stream: StreamPublicSchema
});

export type GetModerationStreamResponse = z.infer<typeof GetModerationStreamResponseSchema>;

export const GetModerationEventResponseSchema = z.object({
    event: EventPublicSchema
});

export type GetModerationEventResponse = z.infer<typeof GetModerationEventResponseSchema>;

export const ApproveContentResponseSchema = z.object({
    status: z.literal('published'),
    publishedAt: IsoDateTimeSchema
});

export type ApproveContentResponse = z.infer<typeof ApproveContentResponseSchema>;

export const RejectContentRequestSchema = z.object({
    reason: z.string().min(10).max(1000)
});

export type RejectContentRequest = z.infer<typeof RejectContentRequestSchema>;

export const RejectContentResponseSchema = z.object({
    status: z.literal('rejected')
});

export type RejectContentResponse = z.infer<typeof RejectContentResponseSchema>;
